import {NgModule} from '@angular/core'

import {SearchPipe} from './Core/search.pipe';
import {LocationsPipe} from './Core/locations.pipe';
import {LocalsPipe} from './Core/locals.pipe';
import {NotificationGroupsPipe} from './Notifications/notification-groups.pipe';
import {NotificationsPipe} from './Notifications/notifications.pipe';
import {DevicesPipe} from './Devices/devices.pipe';
import {UsersPipe} from './Users/users.pipe';
import {FoldersPipe} from './Rrhh/Folders/folders.pipe';
import {HolidaysPipe} from './Rrhh/Holidays/holidays.pipe';
import {PublicHolidaysPipe} from './Rrhh/Public-holidays/publicHolidays.pipe';
import {ClockInPipe} from './Rrhh/Clock-in/clock-in.pipe';
import {SchedulesPipe} from './Rrhh/Schedules/schedules.pipe';
import {ProvidersPipe} from './Purchases/Providers/providers.pipe';
import {OrdersPipe} from './Purchases/Orders/orders.pipe';
import {OrderLinesPipe} from './Purchases/Orders/order-lines.pipe';
import {ProviderProductsPipe} from './Purchases/Providers/provider-products.pipe';
import {DeliveryNotesPipe} from './Purchases/Delivery-notes/delivery-notes.pipe';
import {DeliveryNotePicturesPipe} from "./Purchases/Delivery-notes/delivery-note-pictures.pipe";
import {UnitsPipe} from './Core/units.pipe';
import {CashClosingPipe} from './Finances/Cash-closing/cash-closing.pipe';
import {PaymentsPipe} from './Finances/Payments/payments.pipe';
import {ExpensesPipe} from './Finances/Expenses/expenses.pipe';
import {RecipesCostingPipe} from './YuChef/Recipes-costing/recipes-costing.pipe';
import {RecipesPipe} from './YuChef/Recipes/recipes.pipe';
import {LabeledPipe} from './YuChef/Labeled/labeled.pipe';
import {MiseEnPlacePipe} from './YuChef/Mise-en-place/mise-en-place.pipe';
import {TasksPipe} from './Tasks/General/tasks.pipe';
import {TasksTypePipe} from './Tasks/General/tasks-type.pipe';
import {TasksTitlePipe} from './Tasks/General/tasks-title.pipe';
import {ModelsPipe} from './Tasks/Checklists/models.pipe';
import {SchedulesChecklistPipe} from './Tasks/Checklists/schedules-checklist.pipe';
import {LocalFamiliesPipe} from './Core/local-families.pipe';
import {SchedulesAppccPipe} from './Tasks/Appccs/schedules-appcc.pipe';
import {PlatformsPipe} from './Tasks/General/platforms.pipe';
import {TasksSubfamilyPipe} from './Tasks/General/tasks-subfamily.pipe';
import {TasksFamilyPipe} from './Tasks/General/tasks-family.pipe';
import {FieldsPipe} from './Tasks/General/fields.pipe';
import {SortByPipe} from './Core/sort-by.pipe';
import {WastagesPipe} from './Warehouse/Wastages/wastages.pipe';
import {TransfersPipe} from './Warehouse/Transfers/transfers.pipe';
import {ProductsPipe} from './Purchases/Products/products.pipe';
import {OperationsPipe} from './Warehouse/Operations/operations.pipe';
import {StocksPipe} from './Warehouse/Stocks/stocks.pipe';
import {RequestsPipe} from './Rrhh/Requests/requests.pipe';
import {UsersContractsPipe} from './Rrhh/Contracts/users-contracts.pipe';
import {ElaborationsPipe} from './YuChef/Elaborations/elaborations.pipe';
import {ModulesPipe} from './Modules/modules.pipe';
import {ModulesItemsPipe} from './Modules/modules-items.pipe';
import {VatProductsPipe} from './Purchases/Delivery-notes/vat-products.pipe';
import {MultisessionUsersPipe} from './Multisession/multisession-users.pipe';
import {WidgetsPipe} from './Widgets/widgets.pipe';
import {WidgetsGroupsPipe} from './Widgets/widgets-groups.pipe';
import {CommunicationPipe} from './Communication/communication.pipe';
import {CommunicationTitlePipe} from './Communication/communication-title.pipe';
import {CommunicationIconPipe} from './Communication/communication-icon.pipe';
import {MachinesPipe} from './Tasks/Appccs/machines.pipe';
import {AssistantSuggestionsPipe} from './Assistant/assistant-suggestions.pipe';
import {EventsPipe} from './Events/events.pipe';
import {CommunicationPermissionPipe} from './Communication/communication-permission.pipe';
import {ProviderCatalogPipe} from './Purchases/Orders/provider-catalog.pipe';
import {ScanStatusLabelPipe} from './Documents-review/scan-status-label-pipe';
import {PersonalExpensesPipe} from './Documents-review/personal-expenses.pipe';
import {GeneralExpensesPipe} from './Documents-review/general-expenses.pipe';
import {DeliveryNotesLinesPipe} from './Purchases/Delivery-notes/delivery-notes-lines-pipe';
import {ScanItemsPipe} from './Purchases/Delivery-notes/scan-items-pipe';
import {UnpairedLinesPipe} from './Purchases/Delivery-notes/unpaired-lines.pipe';
import {RolesPipe} from './Core/roles.pipe';

const declarationsExports: any[] = [
  SearchPipe,
  LocationsPipe,
  LocalsPipe,
  NotificationGroupsPipe,
  NotificationsPipe,
  UsersPipe,
  DevicesPipe,
  FoldersPipe,
  HolidaysPipe,
  PublicHolidaysPipe,
  RequestsPipe,
  ClockInPipe,
  SchedulesPipe,
  OrdersPipe,
  OrderLinesPipe,
  ProviderProductsPipe,
  DeliveryNotesPipe,
  DeliveryNotePicturesPipe,
  ProvidersPipe,
  UnitsPipe,
  CashClosingPipe,
  PaymentsPipe,
  ExpensesPipe,
  RecipesCostingPipe,
  RecipesPipe,
  ElaborationsPipe,
  LabeledPipe,
  MiseEnPlacePipe,
  TasksPipe,
  TasksTypePipe,
  TasksTitlePipe,
  ModelsPipe,
  SchedulesChecklistPipe,
  LocalFamiliesPipe,
  SchedulesAppccPipe,
  PlatformsPipe,
  TasksFamilyPipe,
  TasksSubfamilyPipe,
  FieldsPipe,
  SortByPipe,
  WastagesPipe,
  TransfersPipe,
  ProductsPipe,
  OperationsPipe,
  StocksPipe,
  RequestsPipe,
  UsersContractsPipe,
  ModulesPipe,
  ModulesItemsPipe,
  VatProductsPipe,
  MultisessionUsersPipe,
  WidgetsPipe,
  WidgetsGroupsPipe,
  CommunicationPipe,
  CommunicationTitlePipe,
  CommunicationIconPipe,
  MachinesPipe,
  AssistantSuggestionsPipe,
  EventsPipe,
  CommunicationPermissionPipe,
  ProviderCatalogPipe,
  DeliveryNotesLinesPipe,
  UnpairedLinesPipe,
  ScanItemsPipe,
  ScanStatusLabelPipe,
  PersonalExpensesPipe,
  GeneralExpensesPipe,
  RolesPipe,
];

@NgModule({
  imports: [],
  declarations: [...declarationsExports],
  exports: [...declarationsExports],
})
export class PipesModule {
}
